import React, { useEffect, useState } from "react";
import { format } from "mathjs";
import styled from "styled-components";
import CountdownTimer from "./CountDown";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { toast } from "react-toastify";
import { PER_USDT_TO_BNB } from "../contracts/contracts";
import useContract from "../hooks/useContract";
import { useWeb3ModalAccount } from "@web3modal/ethers/react";
import { useWeb3Modal } from "@web3modal/ethers/react";
import ClipLoader from "react-spinners/ClipLoader";
import { FaTelegramPlane, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import CopyToClipboardButton from "./CoppyBtn";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { PRESALE_CONTRACT_ADDRESS, PRESALE_ABI } from "../contracts/contracts";
import Web3 from "web3";
import CustomPieChart from "./CustomPieChart";
import TimelineRoadmap from "./TimelineRoadmap";
import {
  Download,
  Wallet,
  Network,
  PlusCircle,
  Link,
  ShoppingCart,
  Info,
} from "lucide-react";
import { ethers } from "ethers";
const axios = require('axios');
// Bct Component
const Bct = ({ active, title, amount, percent, setActiveCard, id, rgb }) => {
  const a = (l) => `rgba(${rgb}, ${l})`;

  return (
    <div
      onMouseEnter={() => setActiveCard(id)}
      style={
        active
          ? {
            boxShadow: `1px 1px 5px rgba(0, 0, 0, 0.3)`,
            border: `1px solid ${a(0.64)}`,
            borderRadius: '12px',
            background: '#0A090E',
          }
          : {}
      }
      className="relative cursor-pointer flex w-full sm:w-[160px] h-[86px] desktop:w-[240px] desktop:h-[112px] p-[12px] desktop:px-[24px] desktop:py-[16px] flex-col justify-between items-start flex-shrink-0"
    >
      {active && (
        <>

        </>
      )}
      <div
        style={active ? { color: a(1) } : { color: '#4A5578' }}
        className="flex w-full justify-between items-center text-start text-wrap text-[13px] desktop:text-[16px] not-italic font-semibold leading-[120%]"
      >
        <p className="whitespace-pre-wrap">{title}</p>
        <p>{percent}%</p>
      </div>
      <p className="text-[#FFF] flex items-center gap-[6px] text-[18px] desktop:text-[20px] font-normal leading-[normal] tracking-[0.4px]">
        <img src="ihkaas.png" alt="" className="w-[20px] h-[20px]" />
        {amount}
      </p>
    </div>
  );
};

// Fct Component (Updated for 2/2 layout)
const Fct = ({ activeCard, setActiveCard }) => {
  const n = [
    {
      title: 'Presale',
      amount: '3B',
      percent: '30',
      id: 1,
      rgb: '61, 241, 157',
    },
    {
      title: 'Liquidity',
      amount: '2.5B',
      percent: '25',
      id: 2,
      rgb: '51,119,255',
    },
    {
      title: 'Burning',
      amount: '1.7B',
      percent: '17',
      id: 3,
      rgb: '255, 69, 0',
    },
    {
      title: 'Ecosystem',
      amount: '600M',
      percent: '6',
      id: 4,
      rgb: '180, 30, 251',
    },
    {
      title: 'Marketing',
      amount: '700M',
      percent: '7',
      id: 5,
      rgb: '250, 48, 192',
    },
    {
      title: 'IHKAAS Mall',
      amount: '800M',
      percent: '8',
      id: 6,
      rgb: '49, 166, 236',
    },
    {
      title: 'Team',
      amount: '400M',
      percent: '4',
      id: 7,
      rgb: '94, 41, 245',
    },
    {
      title: 'Charity',
      amount: '300M',
      percent: '3',
      id: 8,
      rgb: '34, 139, 34',
    }
  ];


  return (
    <div className="relative rounded-[12px] w-full py-[24px] flex justify-center">
      <div className="grid grid-cols-2 gap-4 w-full max-w-2xl">
        {n.map((r) => (
          <div key={r.id} className="flex justify-center">
            <Bct
              active={activeCard === r.id}
              title={r.title}
              amount={r.amount}
              percent={r.percent}
              id={r.id}
              rgb={r.rgb}
              setActiveCard={setActiveCard}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

// import { FaTelegramPlane } from "react-icons/fa";
// import { FaDiscord } from "react-icons/fa";
// import { FaTwitter } from "react-icons/fa";
// import Iconslink from "../assets/Linktree-Emblem-removebg-preview.png";
// import Roadmap from "../assets/RMupdate.jpg";
// import AutoSlider from "./AutoSlider.js";
// Styled Components
const WalletButton = styled.button`
  background:rgb(0, 0, 0); /* Blue background */
  color: #efc75e;
  font-weight: bold;
  padding: 10px 25px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  letter-spacing: 1.1px;
  transform: skew(-15deg); /* Creates the skewed effect */
  transition: all 0.3s ease;

  &:hover {
    transform: skew(-15deg) scale(1.05); /* Slight scaling on hover */
    box-shadow: 0px 6px 12px rgba(66, 133, 244, 0.4);
  }

  &:active {
    transform: skew(-15deg) scale(0.95);
    box-shadow: 0px 4px 8px rgba(66, 133, 244, 0.3);
  }

  /* Text inside the button should be straight */
  span {
    display: inline-block;
    transform: skew(15deg);
  }


`;
const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

const HeroSection = styled.section`
  display: flex;
  height: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1em;
    width: 95%;
    margin: auto;
    margin-top: 3em;
  }

  .left {
    width: 60%;
    height: 100%;
    background: linear-gradient(
      to right,
      rgba(171, 130, 171, 0.2),
      rgba(88, 133, 191, 0.2),
      rgba(102, 125, 111, 0.2)
    );
    border: 1px solid rgba(68, 68, 68, 1);
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    justify-content: flex-start;

    @media (max-width: 768px) {
      width: 100%;
    }
    .main-heading {
      flex-wrap: wrap;
    }

    .live {
      background: linear-gradient(
        90deg,
        #ce89ca 0%,
        #5885bf 33.33%,
        #7258df 66.67%,
        #75eea3 100%
      );
      clip-path: polygon(
        0% 1em,
        1em 0%,
        100% 0%,
        100% calc(100% - 1em),
        calc(100% - 1em) 100%,
        0 100%
      );
      color: #fff;
      font-size: 0.875rem;
      letter-spacing: 0.02857em;
      min-width: 64px;
      padding: 8px 10px;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 1rem;

      i {
        margin-right: 0.2rem;
      }

      .icon {
        border-radius: 50%;
        padding: 0.2rem;
        margin-right: 0.2rem;
      }
    }

    .live:hover {
      transform: scale(1.05);
    }
    .presale-details {
      display: flex;
      flex-direction: column;
      gap: 0.2em;
      padding: 0rem 1rem 1rem 1rem;

      p {
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
      }

      .token {
        color: #fff;
        background: rgba(255, 255, 255, 0.3);
        padding: 0.1rem 0.5rem;
        border-radius: 2rem;
        font-weight: 500;
        font-size: 0.875rem;
        min-width: 64px;
        text-align: center;
      }
    }

    h1 {
      text-transform: none;
      font-size: 60px;
      font-weight: 800;
      color: #fff;
    }

    p {
      font-size: 24px;
      font-weight: 500;
    }
  }

  .right {
    width: 35%;
    margin: auto;
    display: flex;
    justify-content: flex-start;
    border: 2px solid black;
    background: linear-gradient(
      to right,
      rgba(171, 130, 171, 0.2),
      rgba(88, 133, 191, 0.2),
      rgba(102, 125, 111, 0.2)
    );
    border: 0;

    flex-direction: column;
    color: #fff;

    @media (max-width: 768px) {
      width: 100%;
      margin-top: 2em;
    }

    h2 {
      font-size: 30px;
      font-weight: 700;
      margin-bottom: 20px;
    }

    .timer {
      color: #fff;
      font-size: 20px;
      font-weight: 900;
    }

    .details {
      margin: 56px 0;
      display: flex;
      flex-direction: column;
      gap: 8px;
      font-weight: 700;
      font-size: 20px;
    }

    .count {
      font-weight: 700;
      font-size: 20px;
      padding-bottom: 16px;
    }

    .contribute {
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-weight: 600;
        font-size: 16px;
      }

      select {
        border: 2px solid #444444;
        padding: 8px;
        color: white;
        background: none;
        font-size: 16px;
        width: 30%;
        border-radius: 8px;
      }
    }

    .amount {
      margin: 15px 0;
      input {
        border: 2px solid #444444;
        padding: 12px;
        font-size: 16px;
        width: 100%;
        background: none;
        border-radius: 8px;
        color: white;
      }
    }

    .total {
      padding: 12px 0;
      font-weight: 700;
      font-size: 20px;
    }

    .buy_btn {
      background: linear-gradient(
        90deg,
        #ce89ca 0%,
        #5885bf 33.33%,
        #7258df 66.67%,
        #75eea3 100%
      );
      color: white;
      font-weight: bold;
      padding: 20px 20px;
      border: none;
      border: 1.02px solid rgba(255, 255, 255, 1);
      cursor: pointer;
      text-transform: uppercase;
      transition: all 0.3s ease;

      font-family: Montserrat;
      font-size: 20px;
      font-weight: 600;
      line-height: 19.5px;
      letter-spacing: -0.02em;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }
    .buy_btn.disabled {
      background: #999999;
      color: white;
    }
  }
`;

export const Footer = styled.footer`
  // background: #000;
  padding-bottom: 2em;
  // position: absolute;
  width: 100%;


  ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 1em;
    color: black;
  }

  li {
    list-style: none;
    color: black;
    font-size: 1em;
    font-weight: 400;
  }
  .container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 3em;
    align-items: center;
    width: 80%;
    margin: auto;
  }

  .first {
    .social-icon {
      display: flex;
      gap: 1em;
      margin: 1em 0;
    }

    p {
      color: black;
      font-size: 1em;
      font-weight: 600;
    }
  }

  .sec {
    color: white;

    h3 {
      color: white;
      padding-bottom: 1.3em;
    }
  }
  }
`;

const MainPage = ({ activeSection = "Buy IHKAAS" }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { open } = useWeb3Modal();
  const { isConnected, address } = useWeb3ModalAccount();
  const [paymenType, setPaymentType] = useState("BNB");
  const [amount, setAmount] = useState();
  const [receiveable, setReceiveable] = useState();

  const [balance, setBalance] = useState(0);
  const [maxBalance, setMaxBalance] = useState(null);
  const [price, setPrice] = useState(0);

  let [loading, setLoading] = useState(false);
  let [color, setColor] = useState("#ffffff");

  const { buy, myTokenBalance, maxBalances, getPrice, claimTokens, claimAirdropTokens } = useContract();
  const [bnbPrices, setBnbPrices] = useState(0);

  const fetchBNBPrices = async () => {
    try {
      const response = await fetch("https://api.binance.com/api/v3/ticker/price?symbol=BNBUSDT");
      const data = await response.json();
      return parseFloat(data.price); // BNB price in USD
    } catch (error) {
      console.error("Error fetching BNB price from Binance:", error);
      return null;
    }
  };
  
  
  // Usage
  fetchBNBPrices().then((price) => console.log("BNB Price:", price));
  
  useEffect(() => {

    const _getPrice = async () => {
      const _price = await getPrice();
      console.log("Price fetched in MainPage:", _price);
      setPrice(_price || 0); // Set price or fallback to 0
      setBnbPrices(_price);

    };

    _getPrice(); // Call it on load
  }, []); // Remove `isConnected` dependency to fetch even if not connected
  const [bnbMarketPrice, setBnbMarketPrice] = useState(0); // Live BNB price from API

  // Function to fetch BNB price from API
  const fetchBnbPrice = async () => {
    try {
      const response = await fetch("https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd");
      const data = await response.json();
      if (data.binancecoin && data.binancecoin.usd) {
        setBnbMarketPrice(data.binancecoin.usd);
      }
    } catch (error) {
      console.error("Error fetching BNB price:", error);
    }
  };

  // Fetch BNB price on component mount & refresh every 30 seconds
  useEffect(() => {
    fetchBnbPrice();
    const interval = setInterval(fetchBnbPrice, 30000); // Update every 30s
    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);


  const handlePaymentChange = (e) => {
    const precision = 15; // Precision for calculations

    const formatValue = (value) => {
      if (Math.abs(value) < 1e-6) {
        // For very small values, use fixed-point notation with high precision
        return value.toFixed(precision);
      }
      return parseFloat(value.toFixed(precision)); // Trim trailing zeros for normal values
    };

    const inputName = e.target.name;
    const inputValue = e.target.value;

    if (inputName === "amount") {
      setAmount(inputValue); // Store raw input as string
      const numericValue = parseFloat(inputValue);
      if (!isNaN(numericValue)) {
        if (paymenType === "BNB") {
          const value = numericValue * price * bnbMarketPrice;
          setReceiveable(formatValue(value).toString());
        } else if (paymenType === "USDT") {
          const value = numericValue * price;
          setReceiveable(formatValue(value).toString());
        } else if (paymenType === "USDC") {
          const value = numericValue * price;
          setReceiveable(formatValue(value).toString());
        }
      }
    } else if (inputName === "receiveable") {
      setReceiveable(inputValue); // Store raw input as string
      const numericValue = parseFloat(inputValue);
      if (!isNaN(numericValue)) {
        if (paymenType === "BNB") {
          const value = numericValue / price / bnbMarketPrice;
          setAmount(formatValue(value).toString());
        } else if (paymenType === "USDT") {
          const value = numericValue / price;
          setAmount(formatValue(value).toString());
        } else if (paymenType === "USDC") {
          const value = numericValue / price;
          setAmount(formatValue(value).toString());
        }
      }
    }
  };
  useEffect(() => {
    const _balance = async () => {
      const _myBalance = await myTokenBalance();
      console.log(_myBalance);
      setBalance(_myBalance);
      const _maxBalance = await maxBalances();
      console.log(_maxBalance);
      setMaxBalance(_maxBalance);
    };
    if (address) _balance();
  }, [address]);


  const [referrer, setReferrer] = useState(null); // State for storing referrer


  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const ref = queryParams.get("ref");
    if (ref) {
      setReferrer(ref); // Store the referrer address
    }
  }, []);





  const [activeIndex, setActiveIndex] = useState(null);
  // Toggle answer visibility
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index); // Close if already open
  };






  const [error, setError] = useState(null); // State for any errors

  const { getPresaleAllocation, getAirdropAllocation, getreferAllocation, getUserTokenBalance } = useContract();



  const [pricePerToken, setPricePerToken] = useState(null); // State for token price
  const [tokensPerUSDT, setTokensFor1USD] = useState(null); // State for tokens per 1 USDT

  useEffect(() => {
    const fetchTokenPrices = async () => {
      try {
        console.log("Connecting to provider...");
        // Connect to the Ethereum network using a public RPC provider
        const provider = new ethers.JsonRpcProvider(
          "https://rpc.ankr.com/bsc/63db7e35a9adc7f8956725d525c93c9bc211f9d03b6224ebdb73a13961c50b40"
        );

        // Create a contract instance
        const contract = new ethers.Contract(
          PRESALE_CONTRACT_ADDRESS,
          PRESALE_ABI,
          provider
        );

        console.log("Fetching perDollarPrice...");
        // Call the `perDollarPrice` function from the contract
        const perDollarPrice = await contract.perDollarPrice();
        console.log("Raw perDollarPrice fetched:", perDollarPrice.toString());

        // Assuming perDollarPrice has 18 decimals, format it correctly
        const decimals = 18;
        const formattedPrice = ethers.formatUnits(perDollarPrice, decimals);
        console.log("Formatted perDollarPrice:", formattedPrice);

        const formattedPriceNum = parseFloat(formattedPrice);
        // Calculate price per token (1 / perDollarPrice in USD)
        const tokenPriceInUSD = (1 / formattedPrice).toFixed(9); // Keep 6 decimal places
        setPricePerToken(tokenPriceInUSD);


        // Calculate how many tokens are equivalent to 1 USD (which is the value of perDollarPrice)
        const tokensPer1USD = formattedPriceNum; // perDollarPrice directly gives tokens per 1 USD
        setTokensFor1USD(tokensPer1USD.toFixed()); // Update the state with the calculated value

        // Calculate how many tokens are equivalent to 1 USDT
        // Tokens per 1 USDT = 1 / perDollarPrice
        // Calculate how many tokens are equivalent to 1 USDT


      } catch (err) {
        console.error("Error fetching prices:", err.message);
        setError("Failed to fetch token price. Please try again later.");
      }
    };

    fetchTokenPrices();
  }, []);








  // State for managing accordion open/close
  const [openSection, setOpenSection] = useState(1);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };



  const getNetwork = (type) => {
    // You can map other payment methods and networks if needed
    switch (type) {
      case "BNB":
        return "Bsc";
      case "USDT":
        return "Bsc";
      case "USDC":
        return "Bsc"; // You can change this to any network you want for USDC
      default:
        return "";
    }
  };
  const buyslides = [
    {
      id: 1,
      title: "Install MetaMask",
      text: (
        <>
          <p className="text-justify text-white" style={{ fontSize: "13px", lineHeight: "1.5" }}>
            MetaMask is a crypto wallet that allows you to interact with decentralized applications (DApps). You need to install it first.
          </p>
          <h3 className="text-justify text-gray-500 text-[16px]">For Desktop (Browser Extension):</h3>
          <ol className="text-justify list-decimal list-inside text-white" style={{ fontSize: "13px", lineHeight: "1.5" }}>
            <li>Open Google Chrome, Firefox, Edge browser.</li>
            <li>
              Visit the official MetaMask website:{" "}
              <a href="https://metamask.io" target="_blank" rel="noopener noreferrer" className="text-[#e1c780]">
                https://metamask.io
              </a>
            </li>
            <li>Click Download and select your browser.</li>
            <li>Follow the installation steps and pin MetaMask to your browser for easy access.</li>
          </ol>
        </>
      ),
      image: "MetaMask_Fox.svg.webp",
      imgClass: "w-24 h-24"
    },
    {
      id: 2,
      title: "Set Up Your MetaMask Wallet",
      text: (
        <>
          <ol className="text-left list-decimal list-inside text-white" style={{ fontSize: "13px", lineHeight: "1.5" }}>
            <li>Open MetaMask and click Create a Wallet (or Import if you already have one).</li>
            <li>Set up a strong password and back up your Secret Recovery Phrase securely.</li>
            <li>Confirm your Secret Recovery Phrase to complete the setup.</li>
            <li>You now have a wallet ready to use.</li>
          </ol>
        </>
      ),
      image: "wallet9.png",
      imgClass: "w-24 h-24"
    },
    {
      id: 3,
      title: "Add BNB Smart Chain (BSC) to MetaMask",
      text: (
        <>
          <p className="text-left text-white" style={{ fontSize: "13px", lineHeight: "1.5" }}>
            By default, MetaMask is on the Ethereum network. You need to add Binance Smart Chain (BSC) to use IHKAAS tokens.
          </p>
        </>
      ),
      image: "bnbnblogo.png",
      imgClass: "w-24 h-24"
    },
    {
      id: 4,
      title: "Import IHKAAS Token into MetaMask",
      text: (
        <>
          <p className="text-left text-white" style={{ fontSize: "13px", lineHeight: "1.5" }}>
            Before connecting your wallet to the IHKAAS DApp, you should first add the IHKAAS token to your MetaMask wallet.
          </p>
        </>
      ),
      image: "ihkaas.png",
      imgClass: "w-24 h-24"
    },
    {
      id: 5,
      title: "Connect MetaMask to IHKAAS Presale DApp",
      text: (
        <>
          <ol className="text-left list-decimal list-inside text-white" style={{ fontSize: "13px", lineHeight: "1.5" }}>
            <li>Visit the IHKAAS presale website.</li>
            <li>Click Connect Wallet (top right button).</li>
            <li>Select MetaMask and approve the connection in the pop-up.</li>
            <li>Your wallet is now linked to the IHKAAS presale.</li>
          </ol>
        </>
      ),
      image: "ihkaas.png",
      imgClass: "w-24 h-24"
    },
    {
      id: 6,
      title: "Buy IHKAAS",
      text: (
        <>
          <ol className="text-left list-decimal list-inside text-white" style={{ fontSize: "13px", lineHeight: "1.5" }}>
            <li>Select a payment method: BNB, USDT, or USDC.</li>
            <li>Enter the amount you want to buy (e.g., $50 worth of IHKAAS tokens).</li>
            <li>Click Approve (for USDT/USDC, first approve spending).</li>
            <li>Click Buy IHKAAS Tokens.</li>
            <li>Confirm the transaction in MetaMask and wait for confirmation.</li>
            <li>Your IHKAAS tokens will be credited to your wallet!</li>
          </ol>
        </>
      ),
      image: "9870741.png",
      imgClass: "w-24 h-24"
    },
    {
      id: 7,
      title: "Important Notes & Final Steps",
      text: (
        <>
          <div className="mt-4 text-white" style={{ fontSize: "13px", lineHeight: "1.5" }}>
            <p className="font-semibold">Final Notes:</p>
            <ul className="list-disc list-inside mt-2">
              <li>Always double-check the official website before making transactions.</li>
              <li>Make sure to save your recovery phrase securely.</li>
              <li>Gas fees may apply when making transactions on the Binance Smart Chain.</li>
            </ul>
            <p className="mt-2">Enjoy your IHKAAS tokens!</p>
          </div>
        </>
      ),
      image: "warning-icon-hi.png",
      imgClass: "w-24 h-24"
    },
  ];
  
  
  












  const slides = [
    {
      id: 1,
      title: "Short-Term Goals (Year 1-2)",
      text: (
        <>
          <h3 className="text-3xl text-white mb-4">Presale & Market Entry</h3>
          <ul className="list-disc list-inside  text-white space-y-2">
            <li>Conduct a presale with an initial duration of a few months, with the possibility of controlled extensions if necessary.</li>
            <li>Complete Cyberscope verification to ensure contract security and transparency.</li>
            <li>Lock €17,000 liquidity for 3 years, reinforcing long-term project stability.</li>
            <li>IHKAAS trading goes live, allowing market participants to buy and sell the token.</li>
            <li>Secure initial exchange listings on accessible small and mid-tier exchanges, improving liquidity and token accessibility.</li>
          </ul>
          <h3 className="text-3xl text-white mt-6 mb-4">IHKAAS Ecosystem Enhancements</h3>
          <ul className="list-disc list-inside  text-white space-y-2">
            <li>IHKAAS Red: Implement burning statistics for transparency and introduce a voluntary burning feature.</li>
            <li>IHKAAS White: Launch charity initiatives, including water projects, food and clothing aid, and other humanitarian efforts.</li>
            <li>IHKAAS Blue: Introduce online sessions, educational lectures, and event payments to enhance community engagement.</li>
            <li>IHKAAS Green: Prepare for future integration into restaurant and retail payments, either post-mall launch or earlier via strategic partnerships.</li>
            <li>Deploy the NFT marketplace, expanding the IHKAAS ecosystem with digital assets and collectibles.</li>
          </ul>
          <h3 className="text-3xl text-white mt-6 mb-4">Business & Community Growth</h3>
          <ul className="list-disc list-inside  text-white space-y-2">
            <li>Initiate marketing campaigns to promote IHKAAS Gold adoption, increasing project visibility.</li>
            <li>Conduct five educational webinars on blockchain technology, cryptocurrency adoption, and IHKAAS ecosystem benefits.</li>
            <li>Introduce user incentives for token burning, reinforcing a deflationary model and long-term token value.</li>
            <li>List on larger mid-tier exchanges after initial launch, further strengthening liquidity and market adoption.</li>
          </ul>
        </>
      ),
      image: "ihkaas.png"
    },
    {
      id: 2,
      title: "Medium-Term Goals (Year 3-5)",
      text: (
        <>
          <h3 className="text-3xl text-white mb-4">Advanced Exchange Listings</h3>
          <ul className="list-disc list-inside  text-white space-y-2">
            <li>Strengthen liquidity pools to enhance trading stability and long-term sustainability.</li>
            <li>Apply for listings on top-tier exchanges, including Binance, Coinbase, and Kraken, to expand IHKAAS’s global market presence.</li>
          </ul>
          <h3 className="text-3xl text-white mt-6 mb-4">Business & Token Adoption Growth</h3>
          <ul className="list-disc list-inside text-white space-y-2">
            <li>Expand IHKAAS token adoption across various industries, increasing its real-world utility.</li>
            <li>Implement strategic fee structures for transactions to support continuous token burning, ensuring long-term scarcity and value appreciation.</li>
            <li>Secure 10+ business partnerships, integrating IHKAAS token as a payment option in real-world businesses.</li>
          </ul>
          <h3 className="text-3xl text-white mt-6 mb-4">Education & Community Growth</h3>
          <ul className="list-disc list-inside text-white space-y-2">
            <li>Organize tech conferences focusing on cryptocurrency adoption, blockchain innovation, and IHKAAS’s role in the digital economy.</li>
          </ul>
        </>
      ),
      image: "ihkaas.png"
    },
    {
      id: 3,
      title: "Long-Term Goals (Year 5-10)",
      text: (
        <>
          <h3 className="text-3xl text-white mb-4">Year 5-7: Global Expansion & Mass Adoption</h3>
          <ul className="list-disc list-inside text text-white space-y-2">
            <li>Achieve widespread use of IHKAAS cryptocurrency, making it a recognized and trusted digital asset for transactions.</li>
            <li>Form international partnerships with businesses, institutions, and financial platforms to promote IHKAAS as a preferred payment method globally.</li>
          </ul>
          <h3 className="text-3xl text-white mt-6 mb-4">Metaverse & AI-Driven Commerce</h3>
          <ul className="list-disc list-inside text-white space-y-2">
            <li>Develop AI-driven commerce solutions for the Virtual IHKAAS Mall, enabling automated and personalized shopping experiences.</li>
          </ul>
          <h3 className="text-3xl text-white mt-6 mb-4">Year 7-10: Sustained Ecosystem Development</h3>
          <ul className="list-disc list-inside text-lg text-white space-y-2">
            <li>Introduce new IHKAAS services based on market trends and user demands to ensure continuous innovation.</li>
            <li>Maintain cutting-edge blockchain security and scalability, optimizing speed, efficiency, and user safety.</li>
          </ul>
          <h3 className="text-3xl text-white mt-6 mb-4">Decentralized Community Governance</h3>
          <ul className="list-disc list-inside text-lg text-white space-y-2">
            <li>Implement a decentralized governance model, allowing the community to participate in decision-making and future development.</li>
            <li>Realize the full vision of the IHKAAS ecosystem, integrating it seamlessly across both virtual and real-world applications.</li>
          </ul>
          <h3 className="text-3xl text-white mt-6 mb-4">Physical Business Integration</h3>
          <ul className="list-disc list-inside text-white space-y-2">
            <li>Expand IHKAAS White charity initiatives worldwide, addressing critical issues such as clean water access, food security, clothing, and humanitarian aid.</li>
            <li>Implement IHKAAS Green in physical locations, enabling restaurants, shopping centers, and retail businesses to accept IHKAAS tokens as a standard payment method.</li>
          </ul>
        </>
      ),
      image: "ihkaas.png"
    },
    {
      id: 4,
      title: "Beyond 10 Years: IHKAAS Mall & Payment Integration",
      text: (
        <>
          <h3 className="text-3xl text-white mb-4">IHKAAS Mall Realization</h3>
          <ul className="list-disc list-inside  text-white space-y-2">
            <li>Build the physical IHKAAS Mall upon successful roadmap completion.</li>
          </ul>
          <h3 className="text-3xl text-white mt-6 mb-4">Integrated Token Burning System</h3>
          <ul className="list-disc list-inside  text-white space-y-2">
            <li>Every store (clothing, shoes, restaurants, food markets, electronics, etc.) in the physical and online mall will contribute to token burning via an IHKAAS fee on product sales.</li>
          </ul>
          <h3 className="text-3xl text-white mt-6 mb-4">IHKAAS as a Payment Standard</h3>
          <ul className="list-disc list-inside  text-white space-y-2">
            <li>Establish IHKAAS cryptocurrency as a leading payment option across all stores.</li>
          </ul>
        </>
      ),
      image: "ihkaas.png"
    },

  ];






  const handleBuy = async () => {
    setLoading(true);

    // Check balances based on payment type
    if (paymenType === "BNB") {
      if (amount > maxBalance.eth) {
        toast.error("Not enough BNB balance");
        setLoading(false);
        return;
      }
    } else if (paymenType === "USDT") {
      if (amount > maxBalance.usdt) {
        toast.error("Not enough USDT balance");
        setLoading(false);
        return;
      }
    } else if (paymenType === "USDC") {
      if (amount > maxBalance.usdc) {
        toast.error("Not enough USDC balance");
        setLoading(false);
        return;
      }
    }

    try {
      // Call the buy function with the referer address
      await buy(paymenType, amount);
      toast.success("Buy Successful");
      window.location.reload();  // Refresh the page or trigger UI updates as needed
    } catch (err) {
      console.error("Error during buy:", err);
      toast.error("Error in Buying");
    }

    setLoading(false);
  };















  const [currentSlide, setCurrentSlide] = useState(0);

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };











  const [buycurrentSlide, buysetCurrentSlide] = useState(0);

  const buyprevSlide = () => {
    buysetCurrentSlide((prev) => (prev === 0 ? buyslides.length - 1 : prev - 1));
  };

  const buynextSlide = () => {
    buysetCurrentSlide((prev) => (prev === buyslides.length - 1 ? 0 : prev + 1));
  };



  const handlePaymentTypechange = (type) => {
    setPaymentType(type);
    setAmount(0);
    setReceiveable(0);
  };




  const leaderboardData = [
    { rank: 1, address: "0xe15f...85dc", Tokens: 9, Distribute: "$1,606" },
    { rank: 2, address: "0x919a...1a63", Tokens: 15, Distribute: "$1,552" },
    { rank: 3, address: "0x1dc4...ef69", Tokens: 27, Distribute: "$1,438" },
    { rank: 4, address: "0x336a...ef9e", Tokens: 20, Distribute: "$1,397" },
    { rank: 5, address: "0xfb85...8001", Tokens: 14, Distribute: "$1,455" },
    { rank: 6, address: "0x99ac...0cb2", Tokens: 20, Distribute: "$1,327" },
    { rank: 7, address: "0x5148...5572", Tokens: 7, Distribute: "$1,330" },
    { rank: 8, address: "FG7Vcn...HJUc", Tokens: 3, Distribute: "$1,318" },
    { rank: 9, address: "0xa123...abcd", Tokens: 10, Distribute: "$1,290" },
    { rank: 0, address: "0xb456...efgh", Tokens: 5, Distribute: "$1,250" },
    { rank: 1, address: "0xc789...ijkl", Tokens: 8, Distribute: "$1,200" },
    { rank: 2, address: "0xd012...mnop", Tokens: 12, Distribute: "$1,150" },
    { rank: 3, address: "0xe345...qrst", Tokens: 6, Distribute: "$1,100" },
    { rank: 4, address: "0xf678...uvwx", Tokens: 9, Distribute: "$1,050" },
    { rank: 5, address: "0xg901...yz12", Tokens: 4, Distribute: "$1,000" },
  ];





  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;
  const totalPages = Math.ceil(leaderboardData.length / itemsPerPage);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const nextPage = () => {
    if ((currentPage + 1) * itemsPerPage < leaderboardData.length) {
      setCurrentPage(currentPage + 1);
    }
  };


  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };





  const [leaderboard, setLeaderboard] = useState([]);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const provider = new ethers.JsonRpcProvider("https://rpc.ankr.com/bsc/63db7e35a9adc7f8956725d525c93c9bc211f9d03b6224ebdb73a13961c50b40");
        const contract = new ethers.Contract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, provider);

        const leaderboardData = [];
        let index = 0;

        while (true) {
          try {
            const userData = await contract.getUserDetailsByIndex(index);

            if (!userData.userAddress || userData.userAddress === ethers.ZeroAddress) break; // Stop when no more users

            leaderboardData.push({
              address: (
                <a
                  href={`https://bscscan.com/address/${userData.userAddress}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {userData.userAddress}
                </a>
              ),
              Tokens: `$${Math.floor(parseFloat(ethers.formatUnits(userData.tokenBalance, 18)))} `, // Convert to readable format and remove decimals
              Distribute: `$${Math.floor(parseFloat(ethers.formatUnits(userData.totalContributedUSD, 18)))} `, // Remove decimals from USD contribution
              totalContributedUSD: parseFloat(ethers.formatUnits(userData.totalContributedUSD, 18)), // Store the USD value for sorting
            });

            index++; // Increment index for next user

          } catch (error) {
            console.error("Error fetching user at index", index, error);
            break; // Stop if contract call fails
          }
        }

        // Sort leaderboard by totalContributedUSD in descending order (highest to lowest)
        leaderboardData.sort((a, b) => b.totalContributedUSD - a.totalContributedUSD);

        // Update state with sorted leaderboard data and assign ranks
        const rankedLeaderboard = leaderboardData.map((user, idx) => ({
          ...user,
          rank: idx + 1, // Assign rank based on sorted order
        }));

        setLeaderboard(rankedLeaderboard);
      } catch (error) {
        console.error("Error fetching leaderboard data:", error);
      }
    };

    fetchLeaderboard();
  }, []);




  const minPurchaseUSD = 0;  // Minimum USD required for booster
  const maxPurchaseUSD = 1000; // Maximum USD limit for full progress
  const barSegments = 45; // Total number of progress segments
  const [bnbPrice, setBnbPrice] = useState(572); // Default BNB price, update dynamically

  // Fetch live BNB price (you should call this in a useEffect)
  const fetchBNBPrice = async () => {
    try {
      const response = await fetch("");
      const data = await response.json();
      setBnbPrice(parseFloat(data.price));
    } catch (error) {
      console.error("Error fetching BNB price:", error);
    }
  };

  // Convert entered amount to USD before calculating booster progress
  const usdAmount = (() => {
    if (paymenType === "BNB") {
      return (Number(amount) || 0) * bnbPrice; // Convert BNB to USD
    } else if (paymenType === "USDT" || paymenType === "USDC") {
      return Number(amount) || 0; // USDT & USDC are already in USD
    }
    return 0;
  })();

  // Ensure progress stays within 0-100%
  const progressPercent = Math.min(100, Math.max(0, ((usdAmount - minPurchaseUSD) / (maxPurchaseUSD - minPurchaseUSD)) * 100));

  // Convert progress percentage to bar segments
  const activeBars = Math.max(1, Math.round((progressPercent / 100) * barSegments));

  useEffect(() => {
    fetchBNBPrice(); // Get the latest BNB price on component mount
  }, [paymenType]); // Refetch if user changes the payment type


  const [currentFunds, setCurrentFunds] = useState(0);
  const [progressPercentage, setProgressPercentage] = useState(0);
  const [filledBars, setFilledBars] = useState(0);
  

  const BSC_RPC_ENDPOINT = "https://rpc.ankr.com/bsc/63db7e35a9adc7f8956725d525c93c9bc211f9d03b6224ebdb73a13961c50b40";
  const FUNDRAISING_GOAL = 25000; // Target: $5 million
  const TOTAL_BARS = 21; // Number of progress bar segments


  const BOOST_FACTOR = 5.8; // Increase to fill bars faster
  

  
  const fetchFundingData = async () => {
    try {
      const provider = new ethers.JsonRpcProvider("https://rpc.ankr.com/bsc/63db7e35a9adc7f8956725d525c93c9bc211f9d03b6224ebdb73a13961c50b40");
      const contract = new ethers.Contract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, provider);
  
      // Fetch total USD raised from the contract
      const rawFunds = await contract.totalUsdRaised();
      const formattedFunds = parseFloat(ethers.formatUnits(rawFunds, 18)).toFixed(2);
  
      setCurrentFunds(formattedFunds);
  
      // Adjust progress with BOOST_FACTOR to increase the per-bar fill rate
      let boostedProgress = (formattedFunds / FUNDRAISING_GOAL) * 100 * BOOST_FACTOR;
      boostedProgress = Math.min(boostedProgress, 100); // Cap at 100%
  
      setProgressPercentage(boostedProgress);
  
      // Each bar now fills faster
      const barsFilled = Math.ceil((boostedProgress / 100) * TOTAL_BARS);
      setFilledBars(barsFilled);
  
    } catch (error) {
      console.error("Error fetching funds:", error);
    }
  };
  
  // Fetch data on mount and update every 15 seconds (faster refresh rate)
  useEffect(() => {
    fetchFundingData();
    const interval = setInterval(fetchFundingData, 15000);
    return () => clearInterval(interval);
  }, []);

  const targetTime = new Date('2027-08-05 23:59:59').getTime();

  const calculateTimeLeft = () => {
    const now = new Date().getTime();
    const difference = targetTime - now;
    return difference > 0
      ? {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / (1000 * 60)) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
      : { days: 0, hours: 0, minutes: 0, seconds: 0 };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);


  const [mytokenBalance, setMyBalance] = useState("0");

  useEffect(() => {
    const fetchBalance = async () => {
      if (isConnected) {
        console.log("🔄 Wallet is connected, fetching balance...");
        const balance = await getUserTokenBalance();
        console.log("🎯 Balance received:", balance);
        setMyBalance(balance);
      }
    };

    fetchBalance();
  }, [isConnected]); // Runs when wallet connects


  const [activeCard, setActiveCard] = useState(1);


  const [userData, setUserData] = useState(null); // Store the user data fetched from the smart contract

  const [searchAddress, setSearchAddress] = useState('');

  const fetchUserData = async (address) => {
    if (!ethers.isAddress(address)) {
      console.error("Invalid wallet address");
      setUserData(null);
      return;
    }

    try {
      const provider = new ethers.JsonRpcProvider("https://rpc.ankr.com/bsc/63db7e35a9adc7f8956725d525c93c9bc211f9d03b6224ebdb73a13961c50b40");
      const contract = new ethers.Contract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, provider);

      const data = await contract.users(address);

      setUserData({
        tokenBalance: ethers.formatUnits(data.token_balance, 18).split(".")[0], // Remove decimals
        usdtContributed: ethers.formatUnits(data.total_contributed_usd, 18).split(".")[0], // Remove decimals
      });
    } catch (error) {
      console.error("Error fetching user data:", error);
      setUserData(null);
    }
  };


  const handleSearchChange = (e) => {
    setSearchAddress(e.target.value);
    if (e.target.value === '') {
      setUserData(null); // Reset if the input is cleared
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchAddress) {
      fetchUserData(searchAddress);
    }
  };


  return (
    <>

      <div className="p-6 sm:p-4 xs:p-2 ml-[0px] sm:ml-[100px] xs:ml-0 mt-10">

        {activeSection === "Buy IHKAAS" && (
          <>







            <div className="w-full px-4 laptop:pl-0 laptop:pr-8 md:top-0 md:left-0 md:w-full  md:overflow-hidden flex justify-center z-[2]">
              <div className="flex flex-col gap-5 tablet:gap-20 md:gap-20 w-[1400%] md:max-w-[1146px] mt-750 md:mt-20">


                <div className="flex justify-center w-full z-[2] px-[16px] laptop:pl-[0px] laptop:pr-[32px]">
                  <div
                    className="flex flex-col gap-[20px] tablet:gap-[36px] max-w-[1146px] w-full pt-[90px] tablet:pt-[0px]">

                    <div style={{ opacity: 1, transform: 'none' }}>
                      <main>
                        <div className="flex mb-[0px] tablet:mb-[0px]">
                          
                          
                          
                          
                          <h2
                            className="tabletSmall:!text-[24px] _title_n4amt_1 text-[24px] laptop:text-[24px] font-semibold leading-[150%] tracking-[0.56px] laptop:tracking-[1.12px] mt-[-8px] pt-[18px] mb-[24px] sm:mt-[-12px] sm:pt-[20px] sm:mb-[32px] md:mt-[-16px] md:pt-[16px] md:mb-[29px]">
                            $ Buy IHKAAS Tokens </h2> 

                        </div> 
           <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-1 md:gap-4 mt-0 mb-0 px-2">
  <p className="text-[#B9C0D4] text-[13px] md:text-base leading-[150%] text-center md:text-left mb-0">
<strong>Smart Contract Address:<br /></strong>0x2f343102e709f1b220b06d309122c1c970390e1e<br />
          <strong>Name:</strong> IHKAAS Ihlas Trusted World<br />
          <strong>Symbol:</strong> IHKAAS<br />
          <strong>Decimals:</strong> 18<br /><br />
</p>
                     
          <img
    src="https://ihkaas.io/wp-content/uploads/2025/05/money-back-badge.png"
    alt="Money Back Guarantee"
     className="w-[140px] md:w-[150px] h-auto -mt-8 md:mt-0"  />
</div>
        
         
    
  
  
  
  
  

 



                        <div className="_layout_4jewq_1">
                          <div className="_wrapper_4jewq_14 py-[16px] px-[12px] flex flex-col relative">
                            <div className="absolute right-0 top-0 rotate-90"><svg
                              xmlns="http://www.w3.org/2000/svg" width={120} height={120}
                              viewBox="0 0 120 120" fill="none"
                              className="absolute top-[0] left-[0] pointer-events-none">
                              <mask id="path-1-inside-1_492_7779" fill="white">
                                <path
                                  d="M12 1.43099e-07C5.37259 6.40674e-08 -6.40674e-08 5.37258 -1.43099e-07 12L-1.43099e-06 120L120 120L120 1.43099e-06L12 1.43099e-07Z">
                                </path>
                              </mask>
                              <path
                                d="M12 -1C4.8203 -1 -1 4.8203 -1 12L-1 120L0.999999 120L1 12C1 5.92487 5.92487 1 12 1L12 -1ZM120 120L120 1.43099e-06L120 120ZM120 -0.999999L12 -1C4.8203 -1 -1 4.8203 -1 12L1 12C1 5.92487 5.92487 1 12 1L120 1L120 -0.999999ZM-1.43099e-06 120L120 120L-1.43099e-06 120Z"
                                fill="url(#paint0_linear_492_7779)" fillOpacity="0.64"
                                mask="url(#path-1-inside-1_492_7779)" />
                              <mask id="path-3-inside-2_492_7779" fill="white">
                                <path
                                  d="M12 1.43099e-07C5.37258 6.40674e-08 -6.40674e-08 5.37258 -1.43099e-07 12L-6.67793e-07 56L56 56L56 6.67793e-07L12 1.43099e-07Z">
                                </path>
                              </mask>
                              <path
                                d="M12 -1C4.8203 -1 -1 4.8203 -1 12L-1 56L0.999999 56L1 12C1 5.92487 5.92487 1 12 1L12 -1ZM56 56L56 6.67793e-07L56 56ZM56 -0.999999L12 -1C4.8203 -1 -1 4.8203 -1 12L1 12C1 5.92487 5.92487 1 12 1L56 1L56 -0.999999ZM-6.67793e-07 56L56 56L-6.67793e-07 56Z"
                                fill="url(#paint1_linear_492_7779)" fillOpacity="0.64"
                                mask="url(#path-3-inside-2_492_7779)" />
                              <defs>
                                <linearGradient id="paint0_linear_492_7779" x1="-2.60672e-06"
                                  y1="120.719" x2="89.3969" y2="-20.0131"
                                  gradientUnits="userSpaceOnUse">
                                  <stop stopColor="#e1c780" stopOpacity={0} />
                                  <stop offset="0.159668" stopColor="#e1c780" />
                                  <stop offset="0.796115" stopColor="#e1c780" />
                                  <stop offset={1} stopColor="#e1c780" stopOpacity={0}>
                                  </stop>
                                </linearGradient>
                                <linearGradient id="paint1_linear_492_7779" x1="-2.76543" y1="55.3979"
                                  x2="45.2488" y2="-7.79701" gradientUnits="userSpaceOnUse">
                                  <stop stopColor="white" stopOpacity={0} />
                                  <stop offset="0.37" stopColor="white" />
                                  <stop offset="0.565" stopColor="white" />
                                  <stop offset={1} stopColor="white" stopOpacity={0} />
                                </linearGradient>
                              </defs>
                            </svg><svg xmlns="http://www.w3.org/2000/svg" width={194} height={194}
                              viewBox="0 0 194 194" fill="none"
                              className="absolute top-[0] left-[0] pointer-events-none">
                                <g clipPath="url(#clip0_543_565)">
                                  <g filter="url(#filter0_f_543_565)">
                                    <ellipse cx="11.5" cy="10.5" rx="78.5" ry="30.5" fill="#e1c780"
                                      fillOpacity="0.32" />
                                  </g>
                                </g>
                                <defs>
                                  <filter id="filter0_f_543_565" x={-147} y={-100} width={317}
                                    height={221} filterUnits="userSpaceOnUse"
                                    colorInterpolationFilters="sRGB">
                                    <feFlood floodOpacity={0} result="BackgroundImageFix">
                                    </feFlood>
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix"
                                      result="shape" />
                                    <feGaussianBlur stdDeviation={40}
                                      result="effect1_foregroundBlur_543_565">
                                    </feGaussianBlur>
                                  </filter>
                                  <clipPath id="clip0_543_565">
                                    <path d="M0 12C0 5.37258 5.37258 0 12 0H194V194H0V12Z"
                                      fill="white" />
                                  </clipPath>
                                </defs>
                              </svg></div>
                            <div className="">
                              <div className="_wrapperInner_4jewq_20 mb-[16px] flex flex-col items-center">
                                <h5 className="_title_4jewq_32 mb-[12px] text-md font-bold text-[#e1c780]">IHKAAS Presale End</h5>
                                <div
                                  className="rounded-[12px] py-[16px] px-[14px] flex items-center justify-center gap-[12px] laptop:mb-[8px]"
                                  style={{ background: "rgba(2, 1, 6, 0.32)", padding: "16px 12px", minWidth: "320px" }}
                                >
                                  {Object.entries(timeLeft).map(([unit, value]) => (
                                    <div key={unit} className="flex flex-col items-center justify-center min-w-[70px]">
                                      <span className="text-[#e1c780] font-[500] leading-[110%] text-[28px] text-shadow">
                                        {String(value).padStart(2, "0")}
                                      </span>
                                      <span className="text-[#e1c780] font-[400] leading-[110%] text-[12px] capitalize text-shadow">
                                        {unit}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>           <div className="_wrapperInner_4jewq_20 mb-[4px]">
                              <h5 className="_title_4jewq_32 mb-[12px]">USD Raised </h5>
                              <div className="flex flex-wrap gap-1.5 md:gap-2 mt-2 justify-center md:justify-start w-full">
                                {[...Array(TOTAL_BARS)].map((_, index) => (
                                  <span
                                    key={index}
                                    className={`w-[8px]  h-[25px] md:h-9 rounded transition-all duration-300 ${index < filledBars ? "bg-[#E1C780]" : "bg-gray-700"
                                      }`}
                                  />
                                ))}
                              </div>

                              <p
                                className="mt-[8px] w-full flex items-center justify-between text-white font-[600] text-[14px] uppercase">
                                <span>${currentFunds.toLocaleString()} </span><span>30,000</span>
                              </p>
                            </div>
                            <div className="_wrapperInner_4jewq_20 mb-[4px]">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-[6px]"><img className="max-w-[16px]"
                                  src="stars.svg" alt="price" /><span
                                    className="text-[#B9C0D4] text-[16px] font-[700] capitalize">Price</span>
                                </div>
                                <div className="flex items-center gap-[6px]"><img className="max-w-[20px]"
                                  src="ihkaas.png" alt="price" /><span
                                    className="text-[#fff] text-[16px] font-[700] capitalize">1
                                    $IHKAAS <span className="text-[#70707B]">=</span>
                                    {pricePerToken}</span></div>
                              </div>
                            </div>
                            <div className="_wrapperInner_4jewq_20 mb-[4px]">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-[6px]"><img className="max-w-[16px]"
                                  src="stars.svg" alt="price" /><span
                                    className="text-[#B9C0D4] text-[16px] font-[700] capitalize">My
                                    Balance</span></div>
                                <div className="flex items-center gap-[6px]"><img className="max-w-[20px]"
                                  src="/ihkaas.png" alt="price" /><span
                                    className="text-[white] text-[16px] font-[700] capitalize">{mytokenBalance} <span></span>
                                    $IHKAAS </span></div>
                              </div>
                            </div>

                            <div className="absolute h-[96px] inset-[auto_-1px_-10px_-1px]"
                              style={{
                                background: 'linear-gradient(0deg, rgb(2, 1, 6) 24.42%, rgba(2, 1, 6, 0) 100%)'
                                , pointerEvents: 'none'
                              }}>
                            </div>
                          </div>








                          <div className="_wrapper_4jewq_14 p-[20px_8px_20px_8px] tabletSmall:p-[20px] relative">
                            <svg xmlns="http://www.w3.org/2000/svg" width={120} height={120} viewBox="0 0 120 120" fill="none" className="absolute top-[0] left-[0] pointer-events-none">
                              <mask id="path-1-inside-1_492_7779" fill="white">
                                <path d="M12 1.43099e-07C5.37259 6.40674e-08 -6.40674e-08 5.37258 -1.43099e-07 12L-1.43099e-06 120L120 120L120 1.43099e-06L12 1.43099e-07Z"></path>
                              </mask>
                              <path d="M12 -1C4.8203 -1 -1 4.8203 -1 12L-1 120L0.999999 120L1 12C1 5.92487 5.92487 1 12 1L12 -1ZM120 120L120 1.43099e-06L120 120ZM120 -0.999999L12 -1C4.8203 -1 -1 4.8203 -1 12L1 12C1 5.92487 5.92487 1 12 1L120 1L120 -0.999999ZM-1.43099e-06 120L120 120L-1.43099e-06 120Z" fill="url(#paint0_linear_492_7779)" fillOpacity="0.64" mask="url(#path-1-inside-1_492_7779)" />
                              <mask id="path-3-inside-2_492_7779" fill="white">
                                <path d="M12 1.43099e-07C5.37258 6.40674e-08 -6.40674e-08 5.37258 -1.43099e-07 12L-6.67793e-07 56L56 56L56 6.67793e-07L12 1.43099e-07Z"></path>
                              </mask>
                              <path d="M12 -1C4.8203 -1 -1 4.8203 -1 12L-1 56L0.999999 56L1 12C1 5.92487 5.92487 1 12 1L12 -1ZM56 56L56 6.67793e-07L56 56ZM56 -0.999999L12 -1C4.8203 -1 -1 4.8203 -1 12L1 12C1 5.92487 5.92487 1 12 1L56 1L56 -0.999999ZM-6.67793e-07 56L56 56L-6.67793e-07 56Z" fill="url(#paint1_linear_492_7779)" fillOpacity="0.64" mask="url(#path-3-inside-2_492_7779)" />
                              <defs>
                                <linearGradient id="paint0_linear_492_7779" x1="-2.60672e-06" y1="120.719" x2="89.3969" y2="-20.0131" gradientUnits="userSpaceOnUse">
                                  <stop stopColor="#e1c780" stopOpacity={0} />
                                  <stop offset="0.159668" stopColor="#e1c780" />
                                  <stop offset="0.796115" stopColor="#e1c780" />
                                  <stop offset={1} stopColor="#e1c780" stopOpacity={0} />
                                </linearGradient>
                                <linearGradient id="paint1_linear_492_7779" x1="-2.76543" y1="55.3979" x2="45.2488" y2="-7.79701" gradientUnits="userSpaceOnUse">
                                  <stop stopColor="white" stopOpacity={0} />
                                  <stop offset="0.37" stopColor="white" />
                                  <stop offset="0.565" stopColor="white" />
                                  <stop offset={1} stopColor="white" stopOpacity={0} />
                                </linearGradient>
                              </defs>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width={194} height={194} viewBox="0 0 194 194" fill="none" className="absolute top-[0] left-[0] pointer-events-none">
                              <g clipPath="url(#clip0_543_565)">
                                <g filter="url(#filter0_f_543_565)">
                                  <ellipse cx="11.5" cy="10.5" rx="78.5" ry="30.5" fill="#e1c780" fillOpacity="0.32" />
                                </g>
                              </g>
                              <defs>
                                <filter id="filter0_f_543_565" x={-147} y={-100} width={317} height={221} filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                  <feFlood floodOpacity={0} result="BackgroundImageFix" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                  <feGaussianBlur stdDeviation={40} result="effect1_foregroundBlur_543_565" />
                                </filter>
                                <clipPath id="clip0_543_565">
                                  <path d="M0 12C0 5.37258 5.37258 0 12 0H194V194H0V12Z" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                            <h5 className="_title_4jewq_32 mb-[12px]">Select a payment method</h5>
                            <div className="flex justify-center flex-nowrap gap-2 mb-4">
                              {["BNB", "USDT", "USDC"].map((type) => (
                                <button
                                  key={type}
                                  onClick={() => handlePaymentTypechange(type)}
                                  className={`_assetBtn_4jewq_40 ${paymenType === type ? "_active_4jewq_50" : ""} flex items-center px-2 py-1 text-xs sm:text-sm`}
                                  style={{ borderWidth: "2px", minWidth: "80px" }}
                                >
                                  <img
                                    src={`./${type}.png`}
                                    alt={type}
                                    className="w-4 h-4 sm:w-6 sm:h-6 mr-1"
                                  />
                                  {type}
                                  <span className="_network_4jewq_60 ml-1 text-[10px] sm:text-xs">{getNetwork(type)}</span>
                                </button>
                              ))}
                            </div>




                            <div className="mt-[16px] relative z-[2]">
                              <div className="grid tabletSmall:grid-cols-2 gap-[8px]">
                                <div className="flex flex-col">
                                  <div className="flex flex-col gap-[12px]">
                                    <label className="_label_4jewq_87">You Pay</label>
                                    <div className="h-[64px] flex items-center gap-[8px] py-[12px] px-[8px] rounded-[8px]" style={{ border: '1px solid rgb(53, 52, 56)', background: 'rgba(2, 1, 6, 0.64)' }}>
                                      <div className="flex items-center gap-[6px] p-[7px_12px_7px_7px] rounded-[35px] shrink-[0]" style={{ background: 'rgba(255, 255, 255, 0.08)' }}>
                                        <img className="w-[26px] h-[26px]" src={`./${paymenType}.png`} alt={paymenType} />
                                        <span className="_symbol_4jewq_54">{paymenType}</span>
                                      </div>
                                      <input
                                        name="amount"
                                        type="number"
                                        placeholder="Enter Your Amount"
                                        className="_input_1sbdo_1 !text-[24px] text-white"
                                        value={amount}
                                        onChange={handlePaymentChange}
                                      />
                                      <button
                                        class="uppercase ml-auto _base_1yibl_1 _size32_1yibl_85 _primary_1yibl_97 _anim_1yibl_12"
                                        onClick={() => setAmount(maxPurchaseUSD)} >MAX</button>                    </div>
                                  </div>
                                </div>
                                <div className="flex flex-col gap-[12px]">
                                  <label className="_label_4jewq_87">Receive</label>
                                  <div className="h-[64px] flex items-center gap-[12px] py-[12px] px-[8px] rounded-[8px]" style={{ border: '1px solid rgb(53, 52, 56)', background: 'rgba(2, 1, 6, 0.64)' }}>
                                    <input
                                      id="amount"
                                      type="number"
                                      name="receiveable"
                                      placeholder="You will get"
                                      
                                      value={receiveable}
                                      onChange={handlePaymentChange}
                                      className="_input_1sbdo_1 !text-[24px]"
                                    />
                                    <img
                                      src="/ihkaas.png"
                                      alt="MushCoin"
                                      className="w-10 h-10"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>







                            <div className="_bonusBlock_4jewq_117">
                              <span className="_title_4jewq_32">Purchase Booster</span>
                              <div className="_wrapper_4jewq_14">
                                <div className="mt-6">
                                  <div className="w-full mt-2">
                                    {/* Progress Bar */}
                                    <div className="flex gap-1.5 md:gap-2 mt-2 justify-center md:justify-start w-full">
                                      {[...Array(barSegments)].map((_, idx) => (
                                        <span
                                          key={idx}
                                          className={`w-2 md:w-full h-5 md:h-9 rounded transition-all duration-300 ${idx < activeBars ? "bg-[#E1C780]" : "bg-gray-700"
                                            }`}
                                        />
                                      ))}
                                    </div>

                                    {/* Labels */}
                                    <div className="flex justify-between text-sm text-gray-300 mt-2">
                                      <span>$10+</span>
                                      <span>$250+</span>
                                      <span>$500+</span>
                                      <span>$750+</span>
                                      <span>$1000+</span>
                                    </div>
                                  </div>
                                  <p className="text-center mt-4 text-lg font-bold text-[#E1C780]">
                                    Booster: {Math.round(progressPercent || 0)}%
                                  </p>
                                </div>
                              </div>
                            </div>











                            <div className="relative mt-[38px]">
                              <div className="absolute w-[653px] h-[119px] rounded-[653px] pointer-events-none" style={{ background: 'rgba(106, 86, 246, 0.36)', filter: 'blur(100px)' }}></div>
                              <img className="absolute top-[-20%] tablet:top-[-60%] left-[50%] translate-x-[-50%] pointer-events-none" src="particles.svg" alt="particles" />
                              <div className="py-[22px] px-[16px] rounded-[12px] relative z-[2]" style={{ border: '1px solid rgba(255, 255, 255, 0.2)', background: 'rgba(38, 39, 43, 0.24)' }}>
                                <div className="absolute top-[-1px] left-[30%] w-[92px] h-[1px]" style={{ background: 'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.64) 31.5%, rgba(255, 255, 255, 0.64) 66.5%, rgba(255, 255, 255, 0) 100%)', filter: 'blur(0.5px)' }}></div>
                                <div className="grid items-center tabletSmall:grid-cols-2 gap-[16px]">
                                  <div className="flex flex-col gap-[4px]">
                                    <div className="flex items-center justify-between py-[12px] px-[8px] rounded-[8px]" style={{ background: 'rgba(255, 255, 255, 0.02)', border: '1px solid rgb(26, 25, 31)' }}>
                                      <div className="flex gap-[6px] mt-[2px]"><img className="max-w-[19px]" src="stars.svg" alt="price" /><span className="_title_4jewq_32">Total Amount</span></div>
                                      <div className="flex items-center gap-[6px]"><img className="w-[24px] h-[24px]" src="ihkaas.png" alt="ihkaas" /><span className="text-white text-[24px] font-[600] leading-[100%]">   {receiveable}</span></div>
                                    </div>
                                  </div>
                                  <div className="flex flex-col items-center space-y-[12px]">



                                    {isConnected ? (

                                      <button className="_base_1yibl_1 _size48_1yibl_40 _primary_1yibl_97 _fullWidth_1yibl_94 _anim_1yibl_12 text-black" onClick={handleBuy}>   {loading ? (
                                        <ClipLoader
                                          color="#fff"
                                          loading={loading}
                                          size={20}
                                          aria-label="Loading Spinner"
                                        />
                                      ) : (
                                        `Buy with ${paymenType}😉` // Display selected payment method
                                      )}</button>




                                    )
                                      : (
                                        // Show Connect Wallet button if wallet is not connected


                                        <button className="_base_1yibl_1 _size48_1yibl_40 _primary_1yibl_97 _fullWidth_1yibl_94 _anim_1yibl_12 text-black" onClick={() => open("Connect")}>Connect Wallet</button>


                                      )}

                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="absolute h-[96px] inset-[auto_-1px_-10px_-1px]" style={{ background: 'linear-gradient(0deg, rgb(2, 1, 6) 24.42%, rgba(2, 1, 6, 0) 100%)', pointerEvents: 'none' }}></div>
                          </div>

                        </div>
                      </main>
                    </div>   
                   
                   
                    <p className="text-justify text-[16px] leading-[160%] tracking-[0.56px] mb-[24px] sm:mb-[32px] md:mb-[40px] text-[#B9C0D4]">

                  

The IHKAAS Project Presale is officially live and will run until August 5th, 2027. But don’t wait too long—if we reach the soft cap earlier, the presale will close ahead of schedule! ⏳<br/>

💡 This investment is designed with security and trust in mind. If we don’t reach the soft cap even after a second extension, your investment will be <strong>fully refunded (excluding transaction fees)</strong>risk free. No surprises. No hidden traps.<br/>

🔥 IHKAAS is more than just a token—it's a 10-year mission to build something powerful. With every transaction, we’re burning tokens and reducing the total supply, helping to increase the value over time. But success isn’t possible without trusted holders like you.<br/>

Are you ready to be part of the revolution? 🌍<br/>
Be early. Be bold. Be IHKAAS. 
<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 0, marginBottom: 0 }}>
  <img
    src="https://ihkaas.io/wp-content/uploads/2025/01/Screenshot_19-1-2025_18658_www.cyberscope.io-removebg-preview.png"
    alt="Cyberscope"
    className="w-[140px] md:w-[170px] h-auto -mt-0 md:mt-0"
  />
  <p style={{ marginTop: 0, marginBottom: 0, color: '#B9C0D4', textAlign: 'center' }}>
    Smart contract will be audited by <strong>Cyberscope</strong> after successful presale!
  </p>
</div>
          </p>
          
          
                    
                    
                    {/* Video Frame Section */}
                    
                                      
                    
                    <div className=" relative flex px-[0px] py-[24px] flex-col items-start gap-[0px] flex-1 ">
                      <p className="text-[#FFF] text-center text-[24px] font-semibold"></p>
                      <div className="w-full h-0 pb-[56.25%] relative">
                        <iframe
                          className="absolute top-0 left-0 w-full h-full rounded-[12px] border border-[#efc75e]"
                          src="https://www.youtube.com/embed/YVxkgGxYJEg?start=12"
                          title="YouTube video"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </>
        )}





        {activeSection === "Roadmap" && (
          <>
         
<TimelineRoadmap/>

          </>
        )}


        {activeSection === "Leaderboard" && (


          <div className="py-20 px-1 rounded-[12px] relative z-[2] max-w-6xl mx-auto ">

            <h1 className="tabletSmall:!text-[24px] _title_n4amt_1 text-[24px] laptop:text-[24px] font-semibold leading-[150%] tracking-[0.56px] laptop:tracking-[1.12px] mt-[-8px] pt-[48px] mb-[24px] sm:mt-[-12px] sm:pt-[20px] sm:mb-[32px] md:mt-[-16px] md:pt-[36px] md:mb-[40px]">
              Leaderboard - Addresses</h1>
            {/* Search Box */}
            <div className="mb-6 mt-6">
              <form onSubmit={handleSearchSubmit} className="flex items-center justify-center gap-2">
                <input
                  type="text"
                  value={searchAddress}
                  onChange={handleSearchChange}
                  placeholder="Enter Address"
                  className="px-4 py-2 rounded-md text-black"
                />
                <button
                  type="submit"
                  className=" text-white px-6 py-2 rounded-md transition-transform transform hover:scale-105 bg-[#A66A33]"
                  disabled={!searchAddress}
                >
                  Search
                </button>
              </form>
            </div>

            {/* Display Search Results */}
            {userData && searchAddress && (












              <div
                className="w-full max-w-[900px] mx-auto rounded-[12px] border-2 border-white/40 bg-[rgba(38,39,43,0.4)] p-4 flex flex-col gap-4 text-center md:flex-row md:justify-between md:items-center md:text-lg"
              >
                {/* Rank Number */}
                <span className="text-white font-bold text-xl md:text-lg">  <img src="user.webp" alt="Token" className="w-6 h-6 mr-2" style={{ borderRadius: "5px" }} /></span>

                {/* Address */}
                <span className="text-gray-300 text-lg md:text-base bg-gray-700 py-1 px-2 rounded-md max-w-[90%] mx-auto overflow-hidden text-ellipsis whitespace-nowrap md:max-w-[250px] md:flex-1 md:text-left">
                  {searchAddress}
                </span>

                {/* Token Balance */}
                <span className="flex items-center text-gray-300 text-lg md:text-base md:flex-1 md:justify-center">
                  <img src="ihkaas.png" alt="Token" className="w-6 h-6 mr-2" />
                  <span>{userData?.tokenBalance} Tokens</span>
                </span>

                {/* USDT Contribution */}
                <span className="text-green-400 font-semibold text-xl md:text-lg md:flex-1 md:text-right">
                  ${userData?.usdtContributed}
                </span>
              </div>



            )}

            {/* Leaderboard Entries */}








            <div className="flex flex-col gap-4 md:gap-3">
              {leaderboard.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage).map((entry, index) => (
                <div
                  key={index}
                  className={`py-3 px-4 rounded-[12px] relative z-[2] w-full ${isMobile ? "flex flex-col gap-4 text-center" : "flex justify-between items-center text-lg py-2 px-4"}`}
                  style={{
                    border: "2px solid rgba(239, 199, 94, 0.5)",
                    background: "rgba(38, 39, 43, 0.4)",
                    width: "100%",
                    maxWidth: "900px",
                    margin: "0 auto",
                  }}
                >
                  <span className="text-white font-bold text-xl md:text-lg">#{entry.rank}</span>
                  <span className={`text-gray-300 text-lg md:text-base ${isMobile ? "bg-gray-700 py-1 px-2 rounded-md block max-w-[90%] mx-auto overflow-hidden text-ellipsis whitespace-nowrap" : "truncate w-[200px]"}`}>
                    {isMobile && typeof entry.address === "string"
                      ? `${entry.address.slice(0, 6)}...${entry.address.slice(-4)}`
                      : entry.address}
                  </span>
                  <span className="flex justify-center text-gray-300 text-lg md:text-base">
                    <img src="ihkaas.png" alt="" className="w-7 h-7 mr-2 ml-[-5px]" />
                    {entry.Tokens} Tokens
                  </span>
                  <span className="text-green-400 font-semibold text-xl md:text-lg">{entry.Distribute}</span>
                </div>
              ))}
            </div>

            {/* Pagination */}
            <div className="flex justify-center mt-6 gap-3">
              <button
                onClick={prevPage}
                disabled={currentPage === 0}
                className="py-2 px-4 bg-gray-700 text-white text-lg rounded-lg disabled:opacity-50"
              >
                ◀
              </button>
              {[...Array(totalPages)].map((_, i) => {
                const pageData = leaderboard.slice(i * itemsPerPage, (i + 1) * itemsPerPage);
                return pageData.length > 0 ? (
                  <button
                    key={i}
                    onClick={() => setCurrentPage(i)}
                    className={`py-2 px-4 text-lg rounded-lg ${currentPage === i ? 'bg-blue-500 text-white' : 'bg-gray-700 text-white'}`}
                  >
                    {i + 1}
                  </button>
                ) : null;
              })}
              <button
                onClick={nextPage}
                disabled={(currentPage + 1) * itemsPerPage >= leaderboard.length}
                className="py-2 px-4 bg-gray-700 text-white text-lg rounded-lg disabled:opacity-50"
              >
                ▶
              </button>
            </div>


          </div>


        )}






        {activeSection === "Tokenomics" && (
          <section id="tokenomics" className="w-full min-h-screen flex justify-center z-[2] px-4 laptop:pl-0 laptop:pr-8">
            <div className="flex flex-col gap-5 tablet:gap-10 w-full md:max-w-[1146px] mt-[0px]">



              <div style={{ opacity: 1, transform: "none" }}>
                <div>
                  <div className="flex mb-[0px] tablet:mb-[0px]">

                    <h1 className="tabletSmall:!text-[24px] _title_n4amt_1 text-[24px] laptop:text-[24px] font-semibold leading-[150%] tracking-[0.56px] laptop:tracking-[1.12px] mt-[-8px] pt-[100px] mb-[24px] sm:mt-[-12px] sm:pt-[20px] sm:mb-[32px] md:mt-[-16px] md:pt-[36px] md:mb-[40px]">
                      IHKAAS Tokenomics</h1>
                  </div>

                  <div className="flex tablet:flex-row flex-col mb-[10px] gap-[16px] items-stretch">

                    <div className="relative rounded-[12px] w-full tablet:w-[468px] min-h-[500px] h-auto 
  border border-solid border-[#efc75e] laptop:bg-[rgba(38,_39,_43,_0.38)] py-[24px] flex-1">

                      <div className="flex mx-auto w-full justify-center flex-wrap gap-[8px] laptop:gap-x-[32px] gap-y-[16px]">
                        <Fct activeCard={activeCard} setActiveCard={setActiveCard} />
                      </div>

                    </div>
                    <div className="relative w-full tablet:w-[468px] min-h-[500px] h-auto rounded-[12px] border border-[#efc75e] flex-shrink-0">
                      <div className="relative laptop:w-fit laptop:mx-auto">
                        <CustomPieChart activeCard={activeCard} />
                      </div>
                    </div>



                  </div>

                  {/* Adjusted margin-top and increased gap between the bottom two boxes */}
                  <div className="flex items-center flex-col laptop:flex-row mt-[40px] gap-[24px] laptop:gap-[32px]">
                    <div className="relative flex px-[32px] py-[24px] flex-col items-start gap-[16px] flex-1 rounded-[20px] border border-[#efc75e]">
                      <p className="text-[#FFF] text-center text-[24px] font-semibold">🔥 IHKAAS Tokenomics – Powering the Future of Crypto, One Burn at a Time!</p>
                      <span className="text-[#B9C0D4] text-[16px] laptop:text-[18px] leading-[160%]">
                      Our tokenomics are designed to create long-term value through smart distribution, powerful burning mechanisms, and real-world utility. Every transaction supports the ecosystem and helps drive IHKAAS to new heights.
                      </span>
                    </div>

                    <div className="relative flex px-[32px] py-[24px] flex-col items-start gap-[16px] flex-1 rounded-[20px] border border-[#efc75e]">
                      <p className="text-[#FFF] text-center text-[24px] font-semibold">💰 Fueling Growth, Securing Value – The Strategic Heartbeat of IHKAAS!</p>
                      <span className="text-[#B9C0D4] text-[16px] laptop:text-[18px] leading-[160%]">
                      With a clear, community-focused structure, IHKAAS tokenomics balance innovation, sustainability, and reward. From liquidity to charity, every token has a purpose—this is how we grow together!
                      </span>
                    </div>
                  </div>
                 
                </div>
              </div>
            </div>
          </section>
        )}




        {activeSection === "Help" && (
          <>

<div className="w-full flex flex-col items-center px-4 sm:px-6 md:px-8">
      <div className="w-full max-w-6xl">
        <h1 className="text-left text-[24px] font-semibold leading-[150%] tracking-[0.56px] pt-[130px] mb-[24px] sm:pt-[20px] sm:mb-[32px] md:pt-[116px] md:mb-[40px] text-white">
          How to Buy IHKAAS Tokens
        </h1>
        
        <div className="w-full p-3 border border-[#e1c780] shadow-lg rounded-lg bg-[#121212]">
        <div className="w-full flex flex-col items-center px-4 sm:px-6 md:px-8">
      <div className="w-full max-w-6xl">
        <Swiper
          modules={[Navigation, Pagination]}
          navigation
          pagination={{ clickable: true }}
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="w-full custom-swiper"
        >
          {buyslides.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div className="border border-[#e1c780] bg-[#1f1f1f] rounded-xl h-[380px] flex flex-col items-center justify-start p-4 shadow-md">
                <img
                  src={slide.image}
                  alt={slide.title}
                  className={`${slide.imgClass} object-contain mb-3`}
                />
                <h2 className="text-md font-bold text-[#e1c780] text-center mb-2">
                  {slide.title}
                </h2>
                <div className="text-xs overflow-auto max-h-[220px] w-full text-white">
                  {slide.text}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="relative flex px-[0px] py-[24px] flex-col items-start gap-[16px] flex-1 ">
                    <p className="text-[#FFF] text-center text-[24px] font-semibold"></p>
                    <div className="w-full h-0 pb-[56.25%] relative">
                      <iframe
                        className="absolute top-0 left-0 w-full h-full rounded-[12px] border border-[#efc75e]"
                        src="https://www.youtube.com/embed/sH9NeTcmcq8"
                        title="YouTube video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
        {/* Pagination Dots */}
        <div className="swiper-pagination mt-6" />
      </div>

      {/* Dot styling */}
      <style jsx>{`
        .custom-swiper .swiper-pagination-bullet {
          width: 12px;
          height: 12px;
          background-color: #e1c780;
          opacity: 0.5;
          margin: 0 6px;
        }

        .custom-swiper .swiper-pagination-bullet-active {
          opacity: 1;
          background-color: #e1c780;
        }

        .swiper-pagination {
          text-align: center;
        }
      `}</style>
    </div>
        </div>
      </div>

      {/* Custom CSS for bigger bullets */}
      <style jsx>{`
        .custom-swiper .swiper-pagination-bullet {
          width: 14px;
          height: 14px;
          background-color: #e1c780;
          opacity: 0.6;
        }
        .custom-swiper .swiper-pagination-bullet-active {
          opacity: 1;
        }
      `}</style>
    </div>


          </>
        )}






        {activeSection === "Whitepaper" && (
          <div className="w-full flex flex-col items-center px-4 sm:px-6 md:px-8">
            <div className="w-full max-w-6xl">
              <h1 className="text-left tabletSmall:!text-[24px] _title_n4amt_1 text-[24px] laptop:text-[24px] font-semibold leading-[150%] tracking-[0.56px] laptop:tracking-[1.12px] mt-[-8px] pt-[130px] mb-[24px] sm:mt-[-12px] sm:pt-[20px] sm:mb-[32px] md:mt-[-16px] md:pt-[116px] md:mb-[40px]">
                IHKAAS White Paper
              </h1>

              <div className="w-full p-3 border border-[#e1c780] shadow-lg rounded-lg bg-[#121212]">
                <iframe
                  src="/White-Paper-IHKAAS.pdf"
                  className="w-full h-[60vh] sm:h-[70vh] md:h-[80vh] lg:h-[150vh] border border-[#e1c780] rounded-lg"
                  title="IHKAAS Whitepaper"
                  aria-label="IHKAAS Whitepaper"
                />
              </div>

              <p className="text-center mt-3 text-lg text-[#e1c780]">
                <a
                  href="/White-Paper-IHKAAS.pdf"
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#e1c780] underline"
                >
                  Download IHKAAS Whitepaper
                </a>
              </p>
            </div>
          </div>
        )}





        <footer className="w-full py-4  text-center text-white">
          <p>&copy; {new Date().getFullYear()} Copyright IHKAAS </p>
        </footer>


      </div >









    </>

  );
};

export default MainPage;
